<template>
  <div style="padding: 10px 14px">
    <h3>隐私协议</h3>
    <p>
      请您仔细阅读本指引并确定了解我们对您个人信息的处理规则。阅读本指引的过程中，如您有问题，请联系我们。
      <strong>如您理解并同意接受本指引，即可点击“同意”开始接受我们的服务。如您不同意本指引中的任何条款，请您立即停止访问和使用。</strong>
    </p>
    <strong><p>1.隐私协议适用范围</p></strong>
    <p>（1）您在使用本应用服务器时留下的个人身份信息；</p>
    <p>（2）您通过本应用服务器与其他您或非您之间传送的各种资讯；</p>
    <p>（3）本应用与商业伙伴共享的其他您或非您的各种信息；</p>
    <p>（4）我们十分注重保护您的个人隐私，并制定了《用户隐私协议》，您确认并同意使用本软件提供的服务将被视为接受《用户隐私协议》。</p>
    <strong><p>2.用户信息收集、使用情况说明</p></strong>
    <strong>
      <p>
        <u>
          2.1
          您注册登录时，我们会收集使用您的个人信息，不限于昵称、头像、手机号码、微信、QQ等，收集这些信息是为了帮助您完成注册、登录及使用软件服务，保护您账户的安全；收集、使用您自行上传的手机号码，以进行电话回访和活动通知。
        </u>
      </p>
    </strong>
    <strong>
      <u>
        <p>
          2.2
          在注册完成后，您可选择提供以下个人信息：您的学校类型、学段信息（示例：小学、初中、高中）、学科信息（示例：语文、数学、英语）。为提升辨识度，其中的昵称、学段学科信息将公开显示（如您在课件库中上传或者下载课件后，在课件库中予以显示）。如果您不提供上述信息，不影响您对软件基本业务功能的使用。
        </p>
      </u>
    </strong>
    <strong>
      <u>
        <p>
          2.3
          我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本协议或其他提示内容的目的和用途来处理您的个人敏感信息。
        </p>
      </u>
    </strong>
    <p>
      2.4
      收集和使用上述信息时，我们将需要向您获取相关的权限：例如相机、相册、麦克风；相关权限均不会默认开启，只有在您明确同意后才会向我们授权。需要特别说明的是，获得相关权限是我们提供相关功能的必要前提，但是我们获得具体某一项权限并不代表我们必然会收集您的相关信息；即使我们已经获得相关权限，也仅在必要时、根据本指引来收集您的相关信息。
    </p>
    <p>
      2.5
      请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中但确需收集您的信息，我们会通过更新本协议、页面提示、交互流程、线下通知等方式另行向您说明信息收集的内容、范围和目的，并征得您的同意。
    </p>
    <strong><p>3.用户信息公开情况说明</p></strong>
    <p>3.1 尊重用户个人隐私是我们的一项基本政策。所以，我们不会在未经合法用户授权时公开、编辑或透露用户的注册资料及保存在本应用中的非公开内容，除非有下列情况：</p>
    <p>（1）有关法律规定或为履行法定职责或者法定义务所必需；</p>
    <p>（2）与国家安全、国防安全、公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p>（3）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
    <p>（4）为维护自身或关联公司的商标权、专利权及其他任何合法权益；</p>
    <p>（5）为应对突发公共卫生事件，或者紧急情况下出于维护您或其他个人的生命、财产等重大合法权益的；</p>
    <p>
      （6）依照《中华人民共和国个人信息保护法》的规定在合理的范围处理您自行公开或者其他已经合法公开的个人信息，您明确拒绝的除外，当所收集信息对您的个人权益有重大影响时，我们会依法取得您的同意；
    </p>
    <p>（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
    <p>（8）维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</p>
    <p>（9）其他需要公开、编辑或透露个人信息的情况。</p>
    <strong><p>4.信息的储存</p></strong>
    <p>
      4.1 我们将在合理的安全水平内使用各种安全保护措施以保障您个人信息的安全。
      <strong>
        <u>
          但是，请您理解，在互联网行业由于技术的限制和飞速发展以及可能存在的各种恶意攻击手段，即便我们竭尽所能加强安全措施，也不可能始终保证信息的百分之百安全，因此，我们不能保证在通过互联网双向传输时任何个人信息的安全性或者完整性。
        </u>
      </strong>
    </p>
    <p>4.2 存储地点：我们会按照适用的中国法律法规的要求，将收集的个人信息存储在中国境内服务器上。未经您同意，我们不会将您的个人信息传输至境外。</p>
    <p>4.3 一般而言，我们仅在法律规定的最短期限下存储您的信息，超过期限会删除您的信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
    <p>（1）为遵守适用的法律法规等有关规定；</p>
    <p>（2）为遵守法院判决、裁定或其他法律程序的规定；</p>
    <p>（3）为遵守相关政府机关或法定授权组织的要求；</p>
    <p>（4）我们有理由确信需要遵守法律法规等有关规定；</p>
    <p>（5）为执行相关服务协议或本指引、维护社会公共利益，为保护我们的客户、我们或关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。</p>
    <p>
      4.4
      我们会按照法律法规规定存储您的个人信息，将在中国境内收集的用户个人信息存储于中国境内。目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们将按相关法律法规要求进行传输和存储。
    </p>
    <strong><p>5.资讯公开与共享</p></strong>
    <p>5.1 我们不会将您的个人信息和资讯故意透露、出租或出售给任何第三方。但以下情况除外：</p>
    <p>（1）您本人同意与第三方共享信息和资讯;</p>
    <p>（2）只有透露您的个人信息和资讯，才能提供您所要求的某种产品和服务;</p>
    <p>
      （3）应代表本应用提供产品或服务的主体的要求提供（除非我们另行通知，否则该等主体无权将相关您个人信息和资讯用于提供产品和服务之外的其他用途）：根据法律法规或行政命令的要求提供;因外部审计需要而提供;您违反了本应用服务条款或任何其他产品及服务的使用规定；经我们评估，您的帐户存在风险，需要加以保护。
    </p>
    <p>
      5.2
      在您使用我们的服务的时候，您同意您的个人信息可以向班级里的其他老师、以及班级中的学生公开。除此之外，我们不会与任何第三方公司、组织和个人分享您的个人信息，&nbsp;但以下情况除外：
    </p>
    <p>（1） 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
    <p>（2）我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
    <p>
      （3）与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
    </p>
    <p>（4）与{{ activationCompany.abbreviation }}品牌旗下产品共享。</p>
    <strong><p>6.您对您个人信息的权利</p></strong>
    <p>
      6.1
      在您使用我们的产品及服务期间，为了您可以更加便捷地访问和管理信息，同时保障注销账户的权利，我们在客户端中均为您提供了相应的操作设置，您可以按照当中的指引进行操作。同时，您也可通过本政策联系我们，要求对个人信息进行浏览、更正或删除。
    </p>
    <p>6.2 下列情形下，您可联系我们的客服，要求删除相应的个人信息：</p>
    <p>（1）我们违反法律、行政法规的规定或者双方的约定收集、存储、使用、对外提供个人信息的；</p>
    <p>（2）超出目的范围或者必要期限收集、存储、使用、对外提供个人信息的；</p>
    <p>（3）您撤回同意的；</p>
    <p>（4）您通过注销等方式终止使用我们所有产品或者服务的。</p>
    <p>6.3 响应您的上述请求</p>
    <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
    <strong><p>7.关爱未成年人</p></strong>
    <p>
      我们重视未成年人的个人信息保护，因本软件的特性，我们不向未成年人提供本软件与服务。在您使用我们的服务过程中，我们推定您具有相应的民事行为能力。
      <strong>
        <u>如您为未成年人，在您使用本软件相关服务之前，您应在您的父母或者其他监护人的监护、指导下仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下向我们提供信息。</u>
      </strong>
    </p>
    <strong><p>8.变更</p></strong>
    <p>
      我们可能会适时对本指引进行修订。当本指引的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的隐私保护指引，并向您说明生效日期。
      <strong>
        <u>请您仔细阅读变更后的隐私保护指引内容，您需要通过再次点击、勾选同意等方式以表示您同意我们按照更新后的隐私保护指引处理您的个人信息。</u>
      </strong>
    </p>
    <strong><p>9.如何联系我们</p></strong>
    <p>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系，我们会按照适用法律法规的要求及时向您回复：</p>
    <p>公司：{{ activationCompany.company }}</p>
    <p>电话：400-632-8880</p>
    <p>联系人：客服专员</p>
    <p>地址：{{ activationCompany.address }}</p>
    <p>
      我们将尽快审核所涉问题，并在验证您的用户身份后及时予以回复。一般情况下，我们将在15个工作日内回复您的请求。如无法响应您的请求，我们会在法律规定的时限要求内，向您发送通知并解释原因。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案：&nbsp;
      <strong>
        <u>向{{ activationCompany.company }}的注册所在地当地法院提起诉讼。</u>
      </strong>
    </p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市晟沃信息科技有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '晟沃'
      }
    }
  },
  created() {
    this.activationCompany = config.companyList[1]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.primaryColor {
  color: #1e80ff;
}
</style>
